import React from 'react';
import AttentionIcon from '@components/icons/FileAttention.svg';
import DocumentIcon from '@components/icons/FileDocument.svg';
import MicrophoneIcon from '@components/icons/FileMicrophone.svg';
import { Loader } from './Loader';

export const Icon: React.FC<{ kind: 'ok' | 'error' | 'progress'; isAudioFile: boolean }> = ({ kind, isAudioFile }) => (
  <div
    className={`h-[40px] w-[40px] rounded-lg grid place-items-center shrink-0 text-[var(--color-surface)] ${kind === 'error' ? 'bg-[var(--color-danger)]' : 'bg-[var(--color-text-muted)]'}`}
  >
    {kind === 'error' ? (
      <AttentionIcon />
    ) : kind === 'ok' ? (
      isAudioFile ? (
        <MicrophoneIcon />
      ) : (
        <DocumentIcon />
      )
    ) : (
      <Loader size={20} />
    )}
  </div>
);
